var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 42.5C84.5 63.2617 69.4351 80.5049 49.6406 83.895V55.2852H59.0435H59.4726L59.5377 54.861L61.422 42.5758L61.5103 42H60.9277H49.6406V34.5279C49.6406 32.92 50.0352 31.3938 51.0019 30.2759C51.9569 29.1715 53.5354 28.3906 56.0668 28.3906H61.4258H61.9258V27.8906V17.4316V17.0097L61.5099 16.9388L61.4258 17.4316C61.5099 16.9388 61.5098 16.9388 61.5098 16.9387L61.5095 16.9387L61.5087 16.9386L61.5057 16.9381L61.4946 16.9362L61.4516 16.929C61.4346 16.9262 61.4139 16.9228 61.3896 16.9188C61.3604 16.9141 61.326 16.9085 61.2866 16.9022C61.1427 16.8792 60.9325 16.8465 60.666 16.8073C60.1331 16.7288 59.3746 16.6244 58.4701 16.5199C56.6631 16.3112 54.2638 16.1016 51.9121 16.1016C46.9573 16.1016 42.8054 17.605 39.8917 20.5214C36.9774 23.4384 35.3594 27.7112 35.3594 33.1367V42H25.0684H24.5684V42.5V54.7852V55.2852H25.0684H35.3594V83.895C15.5649 80.5049 0.5 63.2613 0.5 42.5C0.5 19.3039 19.3042 0.5 42.5 0.5C65.6958 0.5 84.5 19.3042 84.5 42.5Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0435 54.7852L60.9277 42.5H49.1406V34.5279C49.1406 31.1664 50.7872 27.8906 56.0668 27.8906H61.4258V17.4316C61.4258 17.4316 56.5622 16.6016 51.9121 16.6016C42.2045 16.6016 35.8594 22.4852 35.8594 33.1367V42.5H25.0684V54.7852H35.8594V84.4837C38.0562 84.828 40.2764 85.0006 42.5 85C44.7236 85.0007 46.9439 84.828 49.1406 84.4837V54.7852H59.0435Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDefault);
export default __webpack_public_path__ + "static/media/facebook_Default.ffbea6a645b1848f25668652c9738740.svg";
export { ForwardRef as ReactComponent };